import request from '@/utils/request'

let Parking_spaceApi = {

  /*车位列表*/
  list(data) {
    return request._post('/shop/plus.parking_space.Index/index', data);
},
/*添加车位*/
add(data) {
    return request._post('/shop/plus.parking_space.Index/add', data);
},
/*修改车位*/
edit(data) {
    return request._post('/shop/plus.parking_space.Index/edit', data);
},
/*删除车位*/
del(data) {
    return request._post('/shop/plus.parking_space.Index/del', data);
},
/*车位详情*/
detail(data) {
  return request._post('/shop/plus.parking_space.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.parking_space.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.parking_space.Setting/getSetting', data, errorback);
    },
}
export default Parking_spaceApi;



// WEBPACK FOOTER //
// ./src/api/parking_space.js